import InputWithStepper, { InputWithStepperProps } from './InputWithStepper';

export type { InputWithStepperProps };
export default InputWithStepper;
